import { Chip } from '@mui/material';

import { getRoleBadgeColor, getRoleDisplayName, sortRoles } from '@utils/roleUtils';

interface RoleChipsProps {
  /** Canonical RBAC roles, in any order. */
  roles: string[] | undefined;
  /** Shown when the user holds no roles in the organization. */
  emptyLabel?: string;
}

/**
 * Renders every RBAC role a user holds, in canonical display order.
 *
 * Roles are a set, not a scalar — a user can be both a practice administrator
 * and a clinician. Colors match the organization members table so the same role
 * reads the same on both pages.
 */
export function RoleChips({ roles, emptyLabel = 'No roles' }: RoleChipsProps) {
  if (!roles?.length) {
    return <Chip label={emptyLabel} size="small" variant="outlined" color="default" />;
  }

  return (
    <>
      {sortRoles(roles).map((role) => (
        <Chip
          key={role}
          label={getRoleDisplayName(role)}
          color={getRoleBadgeColor(role)}
          size="small"
        />
      ))}
    </>
  );
}
